import {
  GET_PROGRESS_BILLINGS,
  GET_PROGRESS_BILLING,
  CREATE_PROGRESS_BILLING,
  UPDATE_PROGRESS_BILLING,
  DELETE_PROGRESS_BILLING,
  APPROVE_PROGRESS_BILLING,
  REJECT_PROGRESS_BILLING,
  SUBMIT_PROGRESS_BILLING,
  GET_PROJECT_BILLING_SUMMARY
} from '../actions/progressBillingActions';

const initialState = {
  billings: [],
  billing: null,
  billingSummary: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const progressBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRESS_BILLINGS:
      return {
        ...state,
        billings: action.payload.billings,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };
      
    case GET_PROGRESS_BILLING:
      return {
        ...state,
        billing: action.payload,
        isLoading: false
      };
      
    case CREATE_PROGRESS_BILLING:
      return {
        ...state,
        billings: [action.payload, ...state.billings]
      };
      
    case UPDATE_PROGRESS_BILLING:
    case SUBMIT_PROGRESS_BILLING:
    case REJECT_PROGRESS_BILLING:
      return {
        ...state,
        billings: state.billings.map(billing => 
          billing._id === action.payload._id ? action.payload : billing
        ),
        billing: action.payload
      };
      
    case APPROVE_PROGRESS_BILLING:
      return {
        ...state,
        billings: state.billings.map(billing => 
          billing._id === action.payload.progressBilling?._id ? action.payload.progressBilling : billing
        ),
        billing: action.payload.progressBilling
      };
      
    case DELETE_PROGRESS_BILLING:
      return {
        ...state,
        billings: state.billings.filter(billing => billing._id !== action.payload)
      };
      
    case GET_PROJECT_BILLING_SUMMARY:
      return {
        ...state,
        billingSummary: action.payload,
        isLoading: false
      };
      
    default:
      return state;
  }
};

export default progressBillingReducer;
